<template>
  <div>
    <div class="head">
      <div class="cent">
        <div class="left">LOGO</div>
        <div class="cent_cet">
          <div
            class="cee"
            v-for="(item, index) in headlist"
            :class="tindex == index ? 'sty' : ''"
            @click="jumphead(item)"
          >
            {{ item.name }}
            <div class="cee_cent" v-if="item.childlist">
              <div
                class="ctt"
                v-for="eitem in item.childlist"
                @click.stop="jumphead(eitem)"
              >
                {{ eitem.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <el-popconfirm title="这是一段内容确定删除吗？">
            <div slot="reference">大大 <i class="el-icon-arrow-down"></i></div>
          </el-popconfirm>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { setStorage } from "@/utils/index";
export default {
  props: {
    tindex: {
      type: [Number, String],
      value: "",
    },
  },
  data() {
    return {
      headlist: [
        {
          name: "首页",
          path: "/index",
        },
        {
          name: "科技金融广场 ",
          path: "/world",
        },
        {
          name: "商品贸易",
          path: "/commodity",
        },
        {
          name: "进出口",
          path: "/exit",
        },
        {
          name: "行业数据",
          path: "",
          childlist: [
            {
              name: "数字经济",
              path: "/industry",
              type: 12,
            },
            {
              name: "一带一路",
              path: "/industry",
              type: 13,
            },
          ],
        },
        {
          name: "财经指数",
          path: "/finance",
        },
        {
          name: "统计资料",
          path: "",
          childlist: [
            {
              name: "期刊论文",
              path: "/paper",
            },
            {
              name: "统计年鉴",
              path: "/yearbooks",
            },
          ],
        },
        {
          name: "数据可视化",
          path: "",
        },
      ],
    };
  },

  created() {
    const that = this;
  },
  methods: {
    jumphead(res) {
      if (res.type) {
        console.log("industryTypeChangeem:",res.type);
        this.$emit("industryTypeChange",res.type)
        setStorage("industryType", res.type);
      }
      this.$router.push({ path: res.path, query: { type: res.type } });
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  .sty {
    background-color: #0052b9;
  }
  width: 100%;
  height: 65px;
  background-color: #1472e7;
  display: flex;
  align-items: center;
  justify-content: center;
  .cent {
    width: 85%;
    min-width: 1200px;
    height: 100%;
    display: flex;
    align-items: center;

    justify-content: space-between;
    .left {
      color: #ffffff;
      font-size: 20px;
      font-weight: 600;
    }
    .cent_cet {
      height: 100%;
      display: flex;
      align-items: center;
      flex: 60%;
      justify-content: center;
      .cee {
        padding: 0 25px;
        height: 100%;
        font-size: 16px;
        color: #fff;
        // font-weight: 550;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        .cee_cent {
          position: absolute;

          top: 65px;
          width: 100%;
          background-color: rgba(0, 82, 185, 0.7);
          display: none;
          flex-direction: column;
          z-index: 999;
          .ctt {
            height: 65px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-bottom: 1px solid #609eeb;
          }
        }
      }
      .cee:hover .cee_cent {
        display: flex;
      }
    }
    .right {
      color: #ffffff;
      cursor: pointer;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// header.vue?afb5c320